import { Injectable } from "@angular/core";
import { DeviceViewModel } from "src/app/shared/models/device.model";
import { StorageService } from "./storage.service";

@Injectable({
    providedIn: 'root'
})
export class DeviceService {
    public device: DeviceViewModel = new DeviceViewModel();

    constructor(
        private storageService: StorageService
    ) {
        this.atualizarDevice();
    }

    public async atualizarDevice() {
        this.device = await this.obterDevice();
    }

    public async obterDevice(): Promise<DeviceViewModel> {
        const deviceSalvo = await this.storageService.get('device');
        if (deviceSalvo != null) {
            return deviceSalvo
        }

        return new DeviceViewModel();
    }

    public async alterarDevice(device: DeviceViewModel) {
        await this.storageService.set('device', device);
        this.atualizarDevice();
    }
}